// @ts-nocheck
export const FCM_TOKEN_REQUEST_LOADING = "FCM_TOKEN_REQUEST_LOADING";
export const FCM_TOKEN_REQUEST_COMPLETE = "FCM_TOKEN_REQUEST_COMPLETE";
export const RESET_FIREBASE_SLICE = "RESET_FIREBASE_SLICE"